<template>
  <div>
    <modal
      id="p-wallet-player-modal"
      class="p-wallet-player-modal-wrapper"
      size="800px"
      :show.sync="show"
      :footer="false"
    >
      <div class="p-wallet-player-modal-wrapper row w-100 flex-column justify-content-center">
          <div class="w-100 d-flex justify-content-center mb-3">
            <h3 class="p-wallet-player-modal-title">توضیحات جام</h3>
          </div>
          <div class="w-100 d-flex justify-content-center mb-4">
            <p class="p-wallet-player-modal-content">{{detailCupSingleData.content}}</p>
          </div>

          <div class="w-100 d-flex justify-content-center ">
            <button @click="closeModal" type="button" class="btn btn-primary btn-blue btn-sm btn-table align-items-center d-flex justify-content-center p-wallet-player-modal-close">
              بستن
              <svg class="p-wallet-player-modal-close" fill="#fff"  enable-background="new 0 0 413.348 413.348" height="512" viewBox="0 0 413.348 413.348" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m413.348 24.354-24.354-24.354-182.32 182.32-182.32-182.32-24.354 24.354 182.32 182.32-182.32 182.32 24.354 24.354 182.32-182.32 182.32 182.32 24.354-24.354-182.32-182.32z"/></svg>
            </button>
          </div>
      </div>

    </modal>
  </div>
</template>

<script>


export default {
    name: 'modalListCup',
    props: {
      active                 : { type: [Boolean, Number], default: false },
      detailCupSingleData    : { type: [Array, Object], default: {} },
    },

    data() {
      return {
      }
    },

    computed: {
      show: {
        set(val) {
          this.$emit('update:active', !!val)
        },
        get() {
          return !!this.active
        }
      },
    },

    mounted () {
    },

    watch: {
      show(){
      }
    },

    methods: {
      closeModal(){
        this.show = false;
      }

    },

}
</script>
